import React from "react";
import { Trash2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { labelClass } from "@/components/Brand";

/** Inline price editing for each subscription plan. */
export const PlanPricingList = ({ plans, onUpdatePrice, onDelete }) => {
  const { t } = useI18n();

  return (
    <div className="border border-[#2A2A2A] bg-[#0F0F0F] p-7" data-testid="plans-list">
      {plans.map((p) => (
        <div key={p.plan_id} className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-4 sm:gap-6 items-end py-5 border-b border-[#1E1E1E]">
          <div>
            <p className="text-sm">{p.name}</p>
            <p className="text-[11px] text-[#707070]">{p.interval_months} mo · {(p.features || []).length} features</p>
          </div>
          <div className="grid grid-cols-2 sm:flex sm:items-end gap-4 sm:gap-6">
            <div className="min-w-0">
              <label className={labelClass}>{t("price")}</label>
              <input data-testid={`plan-price-${p.plan_id}`} type="number" defaultValue={p.price_idr}
                onKeyDown={(e) => e.key === "Enter" && onUpdatePrice(p, e.target.value, null)}
                onBlur={(e) => e.target.value !== String(p.price_idr) && onUpdatePrice(p, e.target.value, null)}
                className="w-full sm:w-28 bg-transparent border-b border-[#2A2A2A] py-1.5 text-xs font-mono-accent focus:border-[#D4AF37] focus:outline-none" />
            </div>
            <div className="min-w-0">
              <label className={labelClass}>{t("original_price")}</label>
              <input data-testid={`plan-original-price-${p.plan_id}`} type="number" defaultValue={p.original_price_idr || 0}
                onKeyDown={(e) => e.key === "Enter" && onUpdatePrice(p, null, e.target.value)}
                onBlur={(e) => e.target.value !== String(p.original_price_idr || 0) && onUpdatePrice(p, null, e.target.value)}
                className="w-full sm:w-28 bg-transparent border-b border-[#2A2A2A] py-1.5 text-xs font-mono-accent text-[#707070] focus:border-[#D4AF37] focus:outline-none" />
            </div>
            <div className="min-w-0">
              <label className={labelClass}>{t("price_usd")}</label>
              <input data-testid={`plan-price-usd-${p.plan_id}`} type="number" step="0.01"
                defaultValue={p.price_usd || 0}
                onKeyDown={(e) => e.key === "Enter" && onUpdatePrice(p, null, null, e.target.value)}
                onBlur={(e) => e.target.value !== String(p.price_usd || 0) && onUpdatePrice(p, null, null, e.target.value)}
                className="w-full sm:w-24 bg-transparent border-b border-[#2A2A2A] py-1.5 text-xs font-mono-accent focus:border-[#D4AF37] focus:outline-none" />
            </div>
            <button data-testid={`delete-plan-${p.plan_id}`} aria-label={t("remove")} onClick={() => onDelete(p)}
              className="justify-self-start text-[#5A5A5A] hover:text-[#8B0000] pb-2"><Trash2 size={14} /></button>
          </div>
        </div>
      ))}
    </div>
  );
};
